import { GroupedUserPermissions, PermissionCode, UserPermission } from 'data/UserPermissions';

const findPermissionByCode = (grouped: GroupedUserPermissions[], code: string): UserPermission | undefined =>
    grouped.flatMap((group) => group.data).find((permission) => permission.code === code);

export const getDependentChanges = (
    permission: UserPermission,
    writeAccess: boolean,
    grouped: GroupedUserPermissions[]
): UserPermission[] => {
    if (permission.code === PermissionCode.OVERRIDE_APPROVAL && writeAccess) {
        const editOrders = findPermissionByCode(grouped, PermissionCode.EDIT_ORDERS);

        return editOrders && !editOrders.writeAccess
            ? [{ ...editOrders, readAccess: false, writeAccess: true }]
            : [];
    }

    if (permission.code === PermissionCode.EDIT_ORDERS && !writeAccess) {
        const overrideApproval = findPermissionByCode(grouped, PermissionCode.OVERRIDE_APPROVAL);

        return overrideApproval && overrideApproval.writeAccess
            ? [{ ...overrideApproval, readAccess: true, writeAccess: false }]
            : [];
    }

    return [];
};

export const mergePermissionChanges = (
    edited: UserPermission[],
    changes: UserPermission[]
): UserPermission[] =>
    changes.reduce((acc, change) => {
        const exists = acc.some((entry) => entry.id === change.id);

        return exists
            ? acc.map((entry) => (entry.id === change.id ? change : entry))
            : [...acc, change];
    }, edited);

export const applyPermissionChanges = (
    grouped: GroupedUserPermissions[],
    changes: UserPermission[]
): GroupedUserPermissions[] => {
    const changeById = new Map(changes.map((change) => [change.id, change]));

    return grouped.map((group) => ({
        ...group,
        data: group.data.map((permission) => {
            const change = changeById.get(permission.id);

            return change
                ? { ...permission, readAccess: change.readAccess, writeAccess: change.writeAccess }
                : permission;
        })
    }));
};
